import { render, staticRenderFns } from "./CommunityLink.vue?vue&type=template&id=ef416328&scoped=true"
import script from "./CommunityLink.vue?vue&type=script&lang=js"
export * from "./CommunityLink.vue?vue&type=script&lang=js"
import style0 from "./CommunityLink.vue?vue&type=style&index=0&id=ef416328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef416328",
  null
  
)

export default component.exports